export const capitalize = (s: string): string => s.replace(/^\w/, c => c.toUpperCase());
